module.exports = __webpack_public_path__ + "static/9-b51ddd85f75c780a12178b1690648cde.jpeg";